import { useEffect } from "react";

const SCRIPT_ID = "zl-widget-s";
const SCRIPT_SRC = "https://platform.docplanner.com/js/widget.js";

const MioDottoreWidget = () => {
  useEffect(() => {
    // Pagina dedicata alla prenotazione: carico subito lo script del widget.
    const existing = document.getElementById(SCRIPT_ID);
    if (existing) {
      // Navigazione SPA di ritorno: rimuovo e ricarico così il widget
      // riprocessa il nuovo anchor .zl-url appena montato.
      existing.remove();
    }
    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.src = SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div className="miodottore-widget">
      <a
        id="zl-url"
        className="zl-url"
        href="https://www.miodottore.it/anna-antoniozzi/psicologo-clinico-psicologo/rieti"
        rel="nofollow"
        data-zlw-doctor="anna-antoniozzi"
        data-zlw-type="big_with_calendar"
        data-zlw-opinion="false"
        data-zlw-hide-branding="true"
        data-zlw-saas-only="true"
      >
        Anna Antoniozzi - MioDottore.it
      </a>
      <noscript>
        <a href="https://www.miodottore.it/anna-antoniozzi/psicologo-clinico-psicologo/rieti">
          Prenota con Anna Antoniozzi su MioDottore.it
        </a>
      </noscript>
    </div>
  );
};

export default MioDottoreWidget;
